<template>
  <div>
    <h3>Pre-Internship Petition (PIP)</h3>
    <div>
      <p>Use this form to:</p>
      <ul>
        <li>Request a New Site be affiliated (site not listed in CHS Placements Database).</li>
        <li>Request approval to intern at your current place of employment (must be related to your current major).</li>
      </ul>
      <p>Please consider: Completion of this form does not guarantee approval. Your Internship Support Coordinator will review the submitted materials and provide you with an updated status of your petition within 2 weeks of submission. Most new site affiliations take 6 to 8 weeks to process, but some can take up to 12 months.</p>
    </div>
    <b-button v-b-modal="modalId" variant="primary flex-float-right" class="mt-sm-2" @click="show=!show">{{modalButtonLabel}}</b-button>
    <additional-material-modal 
      :modalId="modalId" 
      :show="show" 
      :title="modalButtonLabel" 
      :additionalMaterialType="pipForm"
      :studentOpportunity="studentOpportunityData"
      :userId="userId"
      @hideModal="hideModal" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import opportunityApi from "../../api/placements/opportunities.js";
import additionalMaterialModal from "../placements/additional-material-modal";

export default {
  data() {
    return {
      pipForm: {},
      modalId: "",
      show: false,
      studentOpportunityData: {
        studentOpportunityId: 0,
        //jobTitle: this.studentOpportunity.jobTitle,
        //otherAddress: this.studentOpportunity.otherAddress,
        //isPaid: this.studentOpportunity.isPaid,
        //isCurrentEmployee: this.studentOpportunity.isCurrentEmployee,
        goals: [],
        supervisors: [],
        //termStart: this.studentOpportunity.opportunity.term.termStart,
        studentOpportunityAdditionalMaterials: [],
        asuriteId: this.userId,
        opportunity: {
          opportunityId: 0,
          termId: 0
        }
      }
    };
  },

  components: {
    additionalMaterialModal
  },

  computed: {
    ...mapState({
      userId: state => state.auth.user.userId
    }),
    modalButtonLabel: function() {
      if (this.pipForm.actionLabel) {
        return this.pipForm.actionLabel;
      }
      return this.pipForm.name;
    }
  },

  methods: {
    hideModal: function(item) {
      if (item.id == this.modalId) {
        this.show = false;
      }
    }
  },

  created() {
    var that = this;
    opportunityApi.getAdditionalMaterial("PIP Form").then(result => {
      that.pipForm = result.data;
      that.modalId = "generate-modal" + this.pipForm.additionalMaterialTypeId;
    });
  }
};
</script>

<style scoped>
</style>
